import React from "react";

import { CloseIcon } from "../../lib/icons";
import { displayPhone, matchesGeography } from "../../lib/utils";

function modalConfigForVariant(variant, hasJourneyTarget) {
  if (variant === "reused") {
    return {
      kicker: "Lead Reused",
      primaryLabel: hasJourneyTarget ? "Open Lead Journey" : "Close",
      title: "Existing lead reused",
    };
  }

  if (variant === "created") {
    return {
      kicker: "Duplicate Logged",
      primaryLabel: hasJourneyTarget ? "Open Lead Journey" : "Close",
      title: "Lead created with duplicate history",
    };
  }

  return {
    kicker: "Duplicate Check",
    primaryLabel: "Continue Anyway",
    title: "Possible duplicate lead found",
  };
}

function DuplicateAlertModal({
  leadId,
  matches,
  message,
  onClose,
  onConfirm,
  onOpenJourney,
  open,
  referenceLead,
  roleScope,
  variant,
}) {
  if (!open) {
    return null;
  }

  const hasJourneyTarget = Boolean(leadId);
  const { kicker, primaryLabel, title } = modalConfigForVariant(variant, hasJourneyTarget);
  const scopeCopy = roleScope?.can_view_cross_city_duplicates
    ? "Cross-city duplicate matches visible in your role scope are shown here."
    : "Only duplicate matches in your visible geography scope are shown here.";

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-panel duplicate-modal" onClick={(event) => event.stopPropagation()}>
        <div className="modal-header">
          <div>
            <p className="modal-kicker">{kicker}</p>
            <h2>{title}</h2>
          </div>
          <button type="button" className="close-button" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>

        <p className="duplicate-modal-copy">
          {message ||
            "Matching contact details already exist. You can still continue, and the system will log the duplicate in the lead journey."}
        </p>
        <p className="duplicate-scope-note">{scopeCopy}</p>

        <div className="duplicate-match-list">
          {matches.length ? (
            matches.map((match) => {
              const sameGeography = matchesGeography(match, referenceLead);

              return (
                <article key={match.id} className="duplicate-match-card">
                  <div>
                    <strong>{match.full_name}</strong>
                    <p>{match.client_id}</p>
                  </div>
                  <div className="duplicate-match-meta">
                    <span>{displayPhone(match, roleScope)}</span>
                    <span>
                      {match.city_name || "Unspecified City"} / {match.region_name || "Unspecified Region"}
                    </span>
                    <span>{match.source_name || "Others"}</span>
                    <span>{match.assigned_agent_name || "Unassigned"}</span>
                    <span className={`duplicate-scope-badge ${sameGeography ? "same" : "cross"}`}>
                      {sameGeography ? "Same geography" : "Cross-city"}
                    </span>
                  </div>
                </article>
              );
            })
          ) : (
            <div className="duplicate-empty-state">
              No matching leads are visible in your current duplicate scope.
            </div>
          )}
        </div>

        <div className="modal-actions">
          <button type="button" className="secondary-ghost" onClick={onClose}>
            {variant === "preview" ? "Cancel" : "Close"}
          </button>
          <button
            type="button"
            className="primary-button modal-submit"
            onClick={variant === "preview" ? onConfirm : onOpenJourney}
          >
            {primaryLabel}
          </button>
        </div>
      </div>
    </div>
  );
}

export default DuplicateAlertModal;
